import css from './aio.less'


const AioRequiredAsterisk = () => <span title="This field is required" className={css.requiredAsterisk}>*</span>
export default AioRequiredAsterisk
